import { CartContext } from '../../../features/cartContext/CartContext'
import { useContext, useState, useEffect } from 'react'

const OrderCard = (props) => {
    const { title, description, price, id, urls } = props
    const [currentImage, setCurrentImage] = useState(0)
     const [imagePath, setImagePath] = useState([])

    const cart = useContext(CartContext)
    const productQuantity = cart.getProductQuantity(id)

    useEffect(() => {
        setImagePath(urls ? urls : "")
    }, [urls])
    const content=  

    <div class="block rounded-lg p-4 shadow-xs shadow-indigo-100">

           {
                urls ?
                    <div class=" hidden h-56 md:grid grid-cols-3 grid-rows-2 gap-1">
                        <div class="h-56 col-start-1 col-span-2 row-start-1 row-span-2">
                            <img
                                alt=""
                                src={urls[currentImage]}
                                // src="https://images.unsplash.com/photo-1613545325278-f24b0cae1224?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
                                class="h-full w-full rounded-xs object-cover"
                            />
                        </div>
                        {urls.map((img, idx) => (

                            <div className={`h-24 col-start-3 col-span-1 row-span-1`}>
                                <img
                                    alt=""
                                    onClick={() => setCurrentImage(idx)}
                                    src={img ? img : "https://flowbite.s3.amazonaws.com/docs/gallery/square/image-3.jpg"}
                                    class="h-24 w-full rounded-xs object-cover cursor-pointer"
                                />
                            </div>

                        ))}

                    </div> :
                    <div class=" hidden h-56 md:grid grid-cols-3 grid-rows-2 gap-1">
                        <div class="h-56 col-start-1 col-span-2 row-start-1 row-span-2">
                            <img
                                alt=""
                                src={props.fPicName}
                                // src="https://images.unsplash.com/photo-1613545325278-f24b0cae1224?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
                                class="h-full w-full rounded-xs object-cover"
                            />
                        </div>

                        <div className={`h-84 col-start-3 col-span-1 row-span-1`}>
                            <img
                                alt=""
                                src={props.fPicName}
                                class="h-28 w-full rounded-xs object-cover cursor-pointer"
                            />
                        </div>

                        <div class="h-28 col-start-3 col-span-1 row-span-1">
                            <img
                                alt=""
                                src={props.fPicName}
                                // src="https://images.unsplash.com/photo-1613545325278-f24b0cae1224?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
                                class="h-28 w-full rounded-xs object-cover cursor-pointer"
                            />
                        </div>


                    </div>

            }
        
            <div className='block md:hidden'>  
                <img
                    alt="food Image"
                    src={props.urls ? props.urls[Math.floor(Math.random() * 4)] : props.fPicName}
                    className="h-56 w-full rounded-xs object-cover cursor-pointer"
                    onClick={() => setCurrentImage(Math.floor(Math.random() * 4))}
                    />
            </div>
            <div class="mt-2">
                <dl>
                    <div>
                        <dt class="sr-only">Price</dt>

                        <dd class="text-sm text-gray-500 text-left">${props.fPrice}</dd>
                    </div>

                    <div>
                        <dt class="sr-only">title</dt>

                        <dd class="font-medium text-left">{title}</dd>
                    </div>
                    <div>
                        <dt class="sr-only">{price}</dt>
                        <dd class="text-sm text-gray-500 text-left">{props.text}</dd>
                    </div>
                </dl>

                <div class="mt-6 flex items-center gap-8 text-xs">
                    <div class="sm:inline-flex sm:shrink-0 sm:items-center sm:gap-2">
                        <svg
                            class="size-4 text-indigo-700"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"

                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            />
                        </svg>



                       
                        <div class="mt-1.5 sm:mt-0">
                            <p class="text-gray-500">{props.servingTime} min</p>
                        </div>
                    </div>

                    <div class="sm:inline-flex sm:shrink-0 sm:items-center sm:gap-1">
                        <svg 
                            class="size-4 text-indigo-700"
                            xmlns="http://www.w3.org/2000/svg"
                             fill="none" viewBox="0 0 24 24"
                             stroke-width="1.5"
                             stroke="currentColor"
                                 >
                          <path 
                                 stroke-linecap="round"
                                 stroke-linejoin="round"
                                 stroke-width="2"
                                 d="M6.633 10.25c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282m0 0h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23H5.904m10.598-9.75H14.25M5.904 18.5c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 0 1-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 9.953 4.167 9.5 5 9.5h1.053c.472 0 .745.556.5.96a8.958 8.958 0 0 0-1.302 4.665c0 1.194.232 2.333.654 3.375Z" />
                        </svg>

                                

                                
                           
                        <div class="mt-1.5 sm:mt-0">
                            <p class="text-gray-500">(800+)</p>
                        </div>
                    </div>
                    <div class="sm:inline-flex sm:shrink-0 sm:items-left sm:gap-2">
                        <div class="sm:inline-flex sm:shrink-0 sm:items-center sm:gap-2">
                            <button
                                onClick={() => cart.addOneToCart(props)}
                                class="flex gap-1 text-slate-900 bg-transparent border border-solid border-purple-200 hover:bg-purple-50 active:bg-purple-100 font-bold uppercase text-xs px-4 py-2 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">
                                Add to Cart
                                <svg
                                    class="size-4 text-indigo-700"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"

                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
                                </svg>

                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    

    let contentTwo= (

        <div className="mx-auto w-full justify-between text-left items-center p-6 bg-white border border-gray-400 dark:border-gray-700">
            <a href="#">
                <h5 className="mb-2 text-[16px] font-medium  text-gray-900 font-Oswald">{title}</h5>
            </a>
            <p className="mb-3 font-Avenir text-[14px] text-gray-900">{props.text}</p>
            <a href="#" className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-gray-700 bg-white">
                ${props.fPrice}
            </a>
            <button onClick={() => cart.addOneToCart(props)}>Add to Cart</button>
        </div>
    )
return content
}

export default OrderCard
